import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { OfferSelectOption } from '@core/offers-ui';
import { DividerComponent } from '@core/user-interface-legacy';
import {
  AddEvaluationDataService,
  AddEvaluationDropdownFormService,
} from '@recruitee/evaluations-logic';
import type { AddEvaluationSubmit } from '@recruitee/evaluations-types';
import {
  AddEvaluationDropdownFooterComponent,
  EvaluationDropdownEmptyStateComponent,
  EvaluationDropdownHeaderComponent,
} from '@recruitee/evaluations-ui';

import { AddEvaluationDropdownFormComponent } from '../add-evaluation-dropdown-form/add-evaluation-dropdown-form.component';

@Component({
  selector: 'rt-add-evaluation-step',
  templateUrl: './add-evaluation-step.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    DividerComponent,
    EvaluationDropdownHeaderComponent,
    EvaluationDropdownEmptyStateComponent,
    AddEvaluationDropdownFooterComponent,
    AddEvaluationDropdownFormComponent,
  ],
})
export class AddEvaluationStepComponent {
  private readonly dataService = inject(AddEvaluationDataService);
  private readonly formService = inject(AddEvaluationDropdownFormService);

  protected readonly form = this.formService.form;
  protected readonly isFormValid = this.formService.isValid;
  protected readonly canManageInterviewTemplates = this.dataService.canManageInterviewTemplates;
  protected readonly allGroupedEvaluationForms = this.dataService.allGroupedEvaluationForms;
  protected readonly visibleTemplates = this.dataService.visibleTemplates;
  protected readonly templatesLoaded = this.dataService.templatesLoaded;

  public readonly offers = input<OfferSelectOption[]>([]);

  public back = output<void>();
  public close = output<void>();
  public submit = output<AddEvaluationSubmit>();

  protected onSubmit(): void {
    const offerId = this.form.controls.offerId.value ?? undefined;

    this.submit.emit({
      templateId: this.form.controls.templateId.value!,
      ...(this.dataService.isTalentPool() ? { talentPoolId: offerId } : { offerId }),
    });
  }
}
